import React, { useContext, useEffect, useState } from "react";
import Client from "../../Assets/Images/client.svg";
import Token from "../../Assets/Images/Token.svg";
import { Link, useNavigate } from "react-router-dom";
import { TokenContext } from "../../Context/TokenContext";

const ClientSnapshot = ({ heading, data }) => {


  //context
  const tokenCtx = useContext(TokenContext)

  // other hooks 
  const navigate = useNavigate();

  // usestates 
  const [sortedData, setSortedData] = useState([data]);

  // useeffects 
  useEffect(() => {
    setSortedData(data);
  }, [data]);

  // functions 
  const handleArrowClick = (id) => {
    const clientData = sortedData.find((client) => client.id === id);
    navigate(`/added-client/${id}`, { state: { client: clientData } });
  };

  // logs 
  // console.log('client-data', data)
  console.log('tokenCtx', tokenCtx)


  return (
    <div className="client-table-container">
      <div className="table-heading">{heading}</div>
      <div className="project-table">

        {Array.isArray(data) && data.length > 0 ?
          <table className="table" style={{ tableLayout: "fixed", width: "100%" }}>
             <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead className="table-header">
              <tr>
                <th className="header-cell"></th>
                <th className="header-cell">Client Name</th>
                <th className="header-cell">Company Name</th>
                <th className="header-cell">Group ID</th>
                <th className="header-cell center-align">Assessments</th>
                <th className="header-cell center-align">Completion Status</th>
                <th className="header-cell">Start Date</th>
                {/* <th className="header-cell"></th> */}
              </tr>
            </thead>
            <tbody className="table-body">
              {data?.map((client, index) => (
                <tr key={client.id} className="table-row" onClick={() => handleArrowClick(client.id)}>
                  <td className="cell order-number">{index + 1}.</td>
                  <td className="cell client-name">{client?.name || client?.title}</td>
                  <td className="cell">{client?.company}</td>
                  <td className="cell">{client?.groupid}</td>
                  <td className="cell center-align">{client?.respondents}</td>
                  <td className="cell center-align">
                    <div className="completion">
                      <span>
                        {client?.completeAssessments ? client?.completeAssessments : 0}/
                        {client?.totalAssessments ? client.totalAssessments : 0}
                      </span>
                      <div className="progress-bar">
                        <div
                          className="progress"
                          style={{
                            width: `${client?.totalAssessments ? (client?.completeAssessments / client?.totalAssessments) * 100 : 0}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td className="cell date-column seven">
                    {client?.created_at ? (() => {
                      const date = new Date(client.created_at);
                      const month = date.toLocaleString("en-US", { month: "short" });
                      const day = String(date.getDate()).padStart(2, "0");
                      const year = date.getFullYear();
                      return `${month} ${day} ${year}`;
                      })()
                    : ""}
                  </td>
                  {/* <td style={{ marginLeft: "10px", cursor: "pointer" }} className="arrow">
                    &gt;
                  </td> */}
                </tr>
              ))
              }

              <tr className="table-row">
                <td className="cell"></td>
              </tr>
            </tbody>
          </table>
          :
          <>
            <div className="table-header no-clients">
              <div className="header-cell one"></div>
              <div className="header-cell two">Client Name</div>
              <div className="header-cell three">Company Name</div>
              <div className="header-cell four">Group ID</div>
              <div className="header-cell five">Assessments</div>
              <div className="header-cell six">Completion Status</div>
              <div className="header-cell seven">Start Date</div>
            </div>
            <div className="table-dashboard-container no-clients">
              <div className="table-row example-word opacity-class">
                <div className="cell-example order-number one"></div>
                <div className="cell-example client-name  two">Example</div>
                <div className="cell-example three"></div>
                <div className="cell-example four"></div>
                <div className="cell-example five"></div>
                <div className="cell-example six"></div>
                <div className="cell-example date-column seven"></div>
                <div></div>
              </div>
              <div className="table-row table-row-example opacity-class">
                <div className="cell-example order-number one"> 1.</div>
                <div className="cell-example client-name  two">Simon Peter</div>
                <div className="cell-example three">Petra</div>
                <div className="cell-example four">Petra001</div>
                <div className="cell-example five"> 5</div>
                <div className="cell-example six">
                  <div className="completion-format">
                    <span> {2}/ {5} </span>
                    <div className="progress-bar">
                      <div className="progress" style={{ width: '40%', }} ></div>
                    </div>
                  </div>
                </div>
                <div className="cell date-column seven">
                  Jan 5 2024
                </div>
                <div></div>
              </div>
              <div className="client-section opacity-class">
                <span className="line1">You haven’t added any clients yet.</span>
                <span className="line2">
                  Add your first client to get started!
                </span>
              </div>

              <div className="inner-section">
                <div className="text get-started-text">Get started</div>
                <div className="second-section">
                  <div className="Add-client">
                    <Link to="/add-client" className="link">
                      <img src={Client} alt="" style={{ marginLeft: "22px" }} />
                      <span>Add Clients</span>
                    </Link>
                  </div>
                  {tokenCtx.selectedToken === 0 ?
                  <>
                  <div className="divider">
                    <div className="line"></div>
                    <span className="or-text">or</span>
                    <div className="line"></div>
                  </div>
                  <div className="buy-token">
                    <Link to="/tokens" className="link">
                      <img src={Token} alt="" style={{ marginLeft: "22px" }} />
                      <span>Buy Tokens</span>
                    </Link>
                  </div>
                  </>
                : null}
                </div>
              </div>
            </div>
          </>
        }
      </div>

    </div>
  );
};

export { ClientSnapshot };
